export default "__VITE_ASSET__a36oyz5O__"